import { formatToCurrency } from "shared/utils";
import { FC, useMemo } from "react";
import { cx } from "utils/classnames";
import { TruncateWithTooltip } from "shared/components/TruncateWithTooltip";

interface FeeDisplayProps {
  feeInCents?: number;
  currency?: string;
  className?: string;
  label?: string;
  labelClassName?: string;
  showSign?: boolean;
  truncateWithTooltip?: boolean;
  truncateWithTooltipMaxWidth?: `${number}px` | number;
}

const FeeDisplay: FC<FeeDisplayProps> = ({
  feeInCents,
  currency,
  className,
  label,
  labelClassName,
  showSign = true,
  truncateWithTooltip = false,
  truncateWithTooltipMaxWidth
}) => {
  const containerClassName = useMemo(() => {
    let colorClass = "text-content-400";
    if (feeInCents && feeInCents > 0) colorClass = "text-success-700";
    else if (feeInCents && feeInCents < 0) colorClass = "text-danger-600";

    return cx(className, colorClass);
  }, [feeInCents, className]);

  if (!feeInCents || !currency) return <p className={className}>--</p>;

  if (truncateWithTooltip)
    return (
      <TruncateWithTooltip
        className={containerClassName}
        maxWidth={truncateWithTooltipMaxWidth}
        content={
          <>
            {label && <span className={labelClassName}>{label}: &nbsp;</span>}

            {formatToCurrency({
              cents: showSign ? feeInCents : Math.abs(feeInCents),
              currency
            })}
          </>
        }
      />
    );

  return (
    <p className={containerClassName}>
      {label && <span className={labelClassName}>{label}: &nbsp;</span>}

      {formatToCurrency({
        cents: showSign ? feeInCents : Math.abs(feeInCents),
        currency
      })}
    </p>
  );
};

export default FeeDisplay;
